import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Services from "@/components/site/Services";
import ProblemSelector from "@/components/site/ProblemSelector";
import ResultsCollage from "@/components/site/ResultsCollage";
import WaterproofingFeature from "@/components/site/WaterproofingFeature";
import ConcreteShowcase from "@/components/site/ConcreteShowcase";
import ProjectGallery from "@/components/site/ProjectGallery";
import WhyPhillips from "@/components/site/WhyPhillips";
import Reviews from "@/components/site/Reviews";
import Stats from "@/components/site/Stats";
import ServiceArea from "@/components/site/ServiceArea";
import EstimateForm from "@/components/site/EstimateForm";
import Footer from "@/components/site/Footer";
import MobileBar from "@/components/site/MobileBar";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -72 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="App bg-[#0A0A0A] text-white overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <TrustBar />
        <EditorialMarquee />
        <Services />
        <ProblemSelector />
        <ResultsCollage />
        <WaterproofingFeature />
        <ConcreteShowcase />
        <ProjectGallery />
        <WhyPhillips />
        <Reviews />
        <Stats />
        <ServiceArea />
        <EstimateForm />
      </main>
      <Footer />
      <MobileBar />
      <Toaster position="top-center" richColors />
    </div>
  );
}
